import { startIdentityVerification } from '@ks/identity-verification/dist/verify-in-ksyoda-and-browser';
import createAxiosInstance from '../../src/core/base/createAxiosInstance';
import createBaseRequest from '../../src/core/base/createBaseRequest';
import createRequestInstance from '../../src/core/base/createRequestInstance';
import createRequestStatic from '../../src/core/base/createRequestStatic';
import errorHocCreator from '../../src/module/error';
import csrfHocCreator from '../../src/module/csrf';
import verificationHocCreator from '../../src/module/verification';
import sig3HocCreator from '../../src/module/sig3';
import traceRequestInterceptor from '../../src/module/trace';
import passRequestInterceptor from '../../src/module/pass';
import debounceInterceptorGenerator from '../../src/module/debounce';
import logInterceptorGenerator from '../../src/module/log';
import platformInterceptor from '../../src/module/platform';
import adapter from '../../src/externals/axios/adapters/xhr';
import { oldAppXsrfConfig, newXsrfConfig } from '../../src/core/xsrf-config';
import { assign } from '../../src/core/utils';
import { createSecAtlasSign2 } from './sig3';
export * from '../../src/core/model';
var create = function (config) {
    var axiosInstance = createAxiosInstance(assign({
        adapter: adapter,
    }, config));
    var baseRequest = createBaseRequest(axiosInstance, config);
    var withOldCsrf = csrfHocCreator(oldAppXsrfConfig);
    var withNewCsrf = csrfHocCreator(newXsrfConfig);
    var withVerification = verificationHocCreator(startIdentityVerification);
    var secAtlasSign2 = createSecAtlasSign2(config.yoda);
    var withSig3 = sig3HocCreator(config, secAtlasSign2);
    var withError = errorHocCreator(config);
    var request = withError(withSig3(withVerification(withNewCsrf(withOldCsrf(baseRequest)))));
    var instance = createRequestInstance(axiosInstance, request);
    var logInterceptors = logInterceptorGenerator(config);
    var _a = logInterceptors || {}, requestInterceptor = _a.requestInterceptor, responseFullfilledInterceptor = _a.responseFullfilledInterceptor, responseRejectedInterceptor = _a.responseRejectedInterceptor;
    instance.interceptors.request.use(requestInterceptor, requestInterceptor);
    instance.interceptors.response.use(responseFullfilledInterceptor, responseRejectedInterceptor);
    instance.interceptors.request.use(traceRequestInterceptor);
    var _b = debounceInterceptorGenerator(config) || {}, _c = _b.requestInterceptors, requestInterceptors = _c === void 0 ? [] : _c, _d = _b.responseInterceptors, responseInterceptors = _d === void 0 ? [] : _d;
    instance.interceptors.request.use.apply(instance.interceptors.request, requestInterceptors);
    instance.interceptors.response.use.apply(instance.interceptors.response, responseInterceptors);
    instance.interceptors.request.use(passRequestInterceptor);
    instance.interceptors.request.use(platformInterceptor);
    return instance;
};
export var app = createRequestStatic(create);
export default app;
//# sourceMappingURL=index.js.map